import { H as Hyperlink, d as defineCustomElement$1 } from './p-03bc42d4.js';
const OwcHyperlink = Hyperlink;
const defineCustomElement = defineCustomElement$1;
export { OwcHyperlink, defineCustomElement };